import React from 'react';
import { message } from 'antd';

/**
 * 签到按钮 - 控制签到与提示
 */
const CheckinSignBtn = React.memo(({ canSign, todayDoneCount, loading, onSign }) => {
    if (!canSign) {
        const hintText = todayDoneCount < 1 ? '至少完成1关才可以签到哦' : '暂不可签到';
        return (
            <button
                type="button"
                className="checkin-sign-btn disabled"
                onClick={() => message.info(hintText)}
            >
                <span>{hintText}</span>
            </button>
        );
    }
    return (
        <button
            type="button"
            className="checkin-sign-btn active"
            disabled={loading}
            onClick={onSign}
        >
            {loading ? '签到中...' : '立即签到'}
        </button>
    );
});

export default CheckinSignBtn;
